module.exports = __webpack_public_path__ + "static/media/finish-drawing.4f6a45ee.gif";